const ProductCard = ({ onClose, product }) => {
  return (
    <div className={`productCard productCard-modal productCard-modal--dark`}>
      <div className="productCard-content">
        <p className="productCard-content__title">{product.name} </p>
        <div className="productCard-content-info">
          <img
            className="productCard-content-info__image"
            src={product.imageUrl}
            alt="produc-image"
          />

          <div className="productCard-content-info-box">
            <p>
              Продажи за последний месяц: <span>{product.lastMonthSales}</span>
            </p>
            <p>
              Контакт для логистики: <span>{product.logistContact}</span>
            </p>
            <p>
              Цена на торговой площадке:{" "}
              <span>{product.marketplacePrice} USD</span>
            </p>
            <p>
              Минимальное количество: <span>{product.minQuantity}</span>
            </p>
            <p>
              Прибыль: <span>{product.profit} USD</span>
            </p>
            <p>
              Цена закупки: <span>{product.purchasePrice} USD</span>
            </p>
            <p>
              Рекомендуемое количество: <span>{product.recQuantity}</span>
            </p>
            <p>
              Стиль: <span>{product.style || "Не указан"}</span>
            </p>
            <p>
              Страны:
              {product.countries.map((country, index) => (
                <span key={index}>{country} </span>
              ))}
            </p>
            <p>
              Контакт поставщика:{" "}
              <a
                href={product.supplierContact}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Ссылка на контакт</span>
              </a>
            </p>
            <p>
              Настйрока рекламы: <span> {product?.commercial} </span>{" "}
            </p>
          </div>
        </div>
        <button className="productCard__closeBtn" onClick={onClose}>
          Назад
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
